import React from "react";
import projectData from "../static/info/projectData";

function Projects() {
  return (
    <div className="mt-[65px] p-5">
      <h1 className="text-2xl sm:text-3xl my-4 font-bold text-center text-heading">
        Projects
      </h1>
      <div className="flex flex-col md:grid md:grid-cols-2 gap-4">
        {projectData.map((item, index) => (
          <div
            key={index}
            className="gradient-bg p-4 flex flex-col gap-2 items-center rounded-xl"
          >
            <p className="text-xl opacity-90 text-heading">{item.name}</p>
            <img
              className="h-[200px] object-cover"
              src={require(`../static/media/pro${item.id}.png`)}
              alt=""
            />
            <p className="text-content text-center opacity-90 text-sm">
              {item.description}
            </p>
            <div>
              <p className="text-heading opacity-80 text-center">TECH</p>
              <div className="roles my-1">
                {item.tech.map((item, index) => (
                  <button key={index} className="text-xs sm:text-sm">
                    {item}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <p className="text-heading opacity-80 text-center">LINKS</p>
              <div className="link-btns gap-2 my-1">
                {item.links.map((item, index) => (
                  <button key={index} className="text-xs sm:text-sm">
                    <a
                      href={item.link}
                      target="_blank"
                      className="w-full text-content flex items-center gap-1"
                    >
                      <i className={item.icon + " text-sm"} />
                      {item.name}
                    </a>
                  </button>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
